module.exports = __webpack_public_path__ + "img/warp_feeder_pid.ee5c2238.svg";